import FormattedMessage from 'features/i18n/FormattedMessage';
import { IntlMessageKeys } from 'features/i18n/IntlMessageKeys';
import { ComponentProps } from 'react';
import useTr, { TranslationFunction } from 'utils/hooks/useTr';

type BaseProps = {
  messageId: IntlMessageKeys;
  values?: ComponentProps<typeof FormattedMessage>['values'];
  linkUri: string;
  linkMessageId: IntlMessageKeys;
  linkMessageValues?: Parameters<TranslationFunction>[1];
};

type PropsWithLinkTranslation = Omit<BaseProps, 'linkUri'> & {
  linkUri?: never;
};

type PropsWithLinkString = Omit<BaseProps, 'linkMessageId' | 'linkMessageValues'> & {
  linkMessageId?: never;
  linkMessageValues?: never;
};

type Props = PropsWithLinkTranslation | PropsWithLinkString;

export const ToastErrorWithLink = ({
  messageId,
  linkMessageId,
  values,
  linkMessageValues,
  linkUri
}: Props) => {
  const translate = useTr();

  const contactLink = linkMessageId ? translate(linkMessageId, linkMessageValues) : linkUri;

  return (
    <FormattedMessage
      id={messageId}
      values={{
        ...values,
        a: (value: string) => (
          <a href={contactLink} rel="noreferrer" target="_blank">
            {value}
          </a>
        )
      }}
    />
  );
};
